import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function RegisterPage() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        const res = await register(email, password, name);
        setSubmitting(false);
        if (res.ok) navigate(searchParams.get("next") || "/dashboard");
        else setError(res.error);
    }

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="label-eyebrow mb-4">/ Become a member</div>
                <h1 className="font-serif text-4xl mb-8">Join <span className="gold-text italic">The Butler Room</span></h1>
                <form onSubmit={onSubmit} className="space-y-5" data-testid="register-form">
                    <div>
                        <label className="text-xs uppercase tracking-widest text-slate-400">Full name</label>
                        <input
                            data-testid="register-name"
                            required value={name} onChange={(e) => setName(e.target.value)}
                            className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-widest text-slate-400">Email</label>
                        <input
                            data-testid="register-email"
                            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                        />
                    </div>
                    <div>
                        <label className="text-xs uppercase tracking-widest text-slate-400">Password</label>
                        <input
                            data-testid="register-password"
                            type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 w-full bg-slate-900 border border-white/10 rounded-sm px-4 py-3 focus:outline-none focus:border-gold"
                        />
                    </div>
                    {error && <div data-testid="register-error" className="text-sm text-red-400">{error}</div>}
                    <button data-testid="register-submit" disabled={submitting} className="btn-gold w-full disabled:opacity-50">
                        {submitting ? "Creating…" : "Create account"}
                    </button>
                    <div className="text-sm text-slate-400 text-center">
                        Already a member? <Link to="/login" className="gold-text hover:underline">Sign in</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
